export enum EProvider
{
    "none" = 0,
    "israir" = 1, 
    "arkia" = 2
}